// extracted by mini-css-extract-plugin
export default {"medicationsContainer":"Medications_medicationsContainer__errlQ"};